export default "__VITE_ASSET__uNyoNBkP__"